"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomLink = exports.NoNotificationsMessage = exports.NotificationsWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const polished_1 = require("polished");
const elements_1 = require("@src/components/elements");
exports.NotificationsWrapper = styled_components_1.default.div ``;
exports.NoNotificationsMessage = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1rem;
	color: ${({ theme }) => theme.color.gray3};
`;
exports.BottomLink = (0, styled_components_1.default)(elements_1.Link) `
	margin: 0.4rem 0 0 0;
	padding: 0.6rem 1rem;
	width: 100%;
	font-size: 0.9rem;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	transition: all 0.2s ease;
	border-radius: 4px;
	position: relative;

	&,
	&:link,
	&:visited,
	&:focus,
	&:hover,
	&:active {
		color: ${props => props.theme.color.brand1};
		background: ${props => (0, polished_1.transparentize)(0.9, props.theme.color.brand4)};
	}
	&:hover,
	&:active {
		background: ${props => (0, polished_1.transparentize)(0.8, props.theme.color.brand4)};
	}
	span {
		margin-top: 0.2rem;
		flex: unset;
	}
`;
